// extracted by mini-css-extract-plugin
export default {"table_text":"components_table_text__lq4Uj","red":"components_red__tFBqc"};